import { render } from "./ProfileAddress.vue?vue&type=template&id=1a755082"
import script from "./ProfileAddress.vue?vue&type=script&lang=js"
export * from "./ProfileAddress.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__